import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NavigationStart, Router } from '@angular/router';
import { LoaderService } from '../services/loader/loader.service';
import { SplunkService } from '../services/splunk/splunk.service';
import { AuthenticationService } from '../services/authentication/authentication.service';
import { ClientService } from '../services/client/client.service';
import { SKIP_ERROR_REDIRECT } from './http-context-tokens';
/**
 * Adds a default error handler to all requests.
 */
@Injectable()

export class GlobalHttpErrorHandlerInterceptor implements HttpInterceptor {
  currentRoutePath: string;
  public CurentRoute;
  constructor(public router: Router,
    private loaderService: LoaderService,
    private splunkService: SplunkService,
    private authenticationService: AuthenticationService,
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.currentRoutePath = `/${event.url}`;
        this.CurentRoute = { Path: this.currentRoutePath };
      }
    });
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse) {
          if (!req.url.includes('splunk/events')) {
            if (error) {
              this.splunkService.log('error', {
                request: error,
                response: { result: error.error }
              }, this.authenticationService.getUserProfile?.UserId);
            }
            this.loaderService.handleSpinner(false);
            if (error.error instanceof ErrorEvent) {
              console.error("Error Event");
            } else {
              console.log(`error status : ${error.status} ${error.statusText}`);
              if (!req.context.get(SKIP_ERROR_REDIRECT)) {
                switch (error.status) {
                  case 401:      //logout and re login
                    this.router.navigateByUrl("/unauthorized");
                    break;
                  case 403:     //forbidden
                    this.router.navigateByUrl("/unauthorized");
                    break;
                  default:
                    this.router.navigateByUrl("/error", { state: this.CurentRoute });
                    break;
                }
              }
            }
          }
        } else {
          console.error("some thing else happened");
        }
        return throwError(error.message);
      })
    )
  }
}